export const authGaurd =  (to, from, guards, guardProps, props) => {
  if ($store.getters['user-state/isAuthenticated']) {
    return true
  }
  props.redirect = { name: 'portal-home-login'}
  return false
}

export default authGaurd
